import React, {Dispatch, useCallback} from 'react';
import {useHistory} from 'react-router';

import {ReferralDetail} from 'referral';
import {useGoToNewOfferPageIfPossible} from '../core/routes';
import {canSubmitNewOffer, canViewAcceptedOffer, canViewSubmittedOffer} from '../domain';
import {ReferralWithMyOrgOffers} from '../hook/useReferralQueryForProvider$';
import {ModalActionPayload} from '../modal/action';
import { useApplicationRootUrl } from 'common/component/ApplicationRootContext';
import {FatGreenOutlineButton, FatAtlantisOutlineButton} from 'common';
import {InquiryRequestIcon} from 'referral/component/InquiryRequestIcon';


type Props = {
    referral: ReferralWithMyOrgOffers,
    dispatch: Dispatch<ModalActionPayload>,
    onReferralInquiry?: (referralGuid: string) => void
}

export function ReferralModalContent({referral, dispatch, onReferralInquiry}: Props) {
    const rootUrl = useApplicationRootUrl();
    const goToNewOfferPageIfPossible = useGoToNewOfferPageIfPossible({
        referralGuid: referral?.guid,
    });
    const submitOffer = useCallback(
        () => {
            dispatch({
                type: 'MODAL_ACTION',
                show: false,
            });
            goToNewOfferPageIfPossible();
        },
        [dispatch, goToNewOfferPageIfPossible]
    );

    return (
        <div className='px-5 flex-auto'>
            <ReferralDetail referral={referral}/>
            <div className="py-5 w-full sticky bottom-0 bg-white pb-4">
                <ViewSubmittedOfferButton referral={referral} rootUrl={rootUrl}/>
                <ViewAcceptedOfferButton referral={referral} rootUrl={rootUrl}/>
                {canSubmitNewOffer(referral) && <FatGreenOutlineButton text="Submit an Offer" onClick={submitOffer}/>}
                {onReferralInquiry && (
                    <div className="pt-2">
                        <FatAtlantisOutlineButton
                            text={referral.incompleteReferralInquiryRequests?.length ? "View Referral Inquiry" : "Submit Referral Inquiry"}
                            onClick={() => onReferralInquiry(referral.guid)}
                            icon={referral.incompleteReferralInquiryRequests?.length ? <InquiryRequestIcon requests={referral.incompleteReferralInquiryRequests}/> : undefined}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

const ViewSubmittedOfferButton = ({referral, rootUrl}: { referral: ReferralWithMyOrgOffers, rootUrl: string }) => {
    const history = useHistory();
    if (canViewSubmittedOffer(referral)) {
        return (
            <FatGreenOutlineButton
                text='View Offer'
                onClick={() => history.push(`${rootUrl}/offer/${referral.myOrgSubmittedOffers?.[0]?.guid}`)}
            />
        );
    }
    return null;
}

const ViewAcceptedOfferButton = ({referral, rootUrl}: { referral: ReferralWithMyOrgOffers, rootUrl: string }) => {
    const history = useHistory();
    if (canViewAcceptedOffer(referral)) {
        return (
            <FatGreenOutlineButton
                text='View Offer'
                onClick={() => history.push(`${rootUrl}/offer/${referral.myOrgAcceptedOffers?.[0]?.guid}`)}
            />
        );
    }
    return null;
}
